import { LinkProps, makeStyles, Theme } from '@material-ui/core'
import { iconStaticClassName } from '../Icon'

export const useLinkStyles = makeStyles<Theme, LinkProps>((theme) => ({
  root: (props) => ({
    display: 'flex',
    ...(props.color === undefined && { color: theme.palette.info.main }),
    [`& .${iconStaticClassName}`]: {
      alignSelf: 'center',
    },
  }),
}))
